"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IndexedPoint2dIdentifier = void 0;
/**
 * @public
 */
exports.IndexedPoint2dIdentifier = Symbol("indexed point2d binder");
//# sourceMappingURL=i-gl-indexed-point2d-binder.js.map